import { render, staticRenderFns } from "./AccountTransferForm.vue?vue&type=template&id=588264f2"
import script from "./AccountTransferForm.vue?vue&type=script&lang=js"
export * from "./AccountTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports